module.exports = __webpack_public_path__ + "img/pictureBar.66f7a89e.png";